export enum VoUsersPermissions {
  Users = 'user-exclusion',
}
